module.exports = __webpack_public_path__ + "static/assets/dd8f636a1df01f3d3768998081387ea4.mp3";